import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig, selectNcFileData, selectNcFileId } from '@reducers/details';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const BatchDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFileData = useSelector(selectNcFileData);
  const ncFileId = useSelector(selectNcFileId);
  const title = useTitle();

  useBatchDetails({
    clearTools: () => dispatch(clearTools()),
    getNCFileById: (id) => dispatch(getNCFileById(id)),
    getTools: (params) => dispatch(getTools(params)),
    productionBatchStatistics: (params) => dispatch(productionBatchStatistics(params)),
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
  });

  const anchorNcFileId = ncFileData.data?.ncFileId ?? ncFileId ?? null;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFileData.wasLoaded} />
      </View>
    </DetailsPageWrapper>
  );
};

export { BatchDetailsNCFileTraceability };
